import React, { useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import { nonEmpty } from "../../utils/service";
import { resetPasswordApi } from "../../api/Api";
import { useEffect } from "react";
export const ResetPasswordContext = createContext({});

export const ResetPasswordContextProvider = ({ children }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [passWordMisMatch, setPasswordMisMatch] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [emptyNewPassword, setEmptyNewPassword] = useState(false);
  const [emptyConfirmPassword, setConfirmPassword] = useState(false);
  const [token, setToken] = useState("");
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const getValidateToken = () => {
    const queryParams = new URLSearchParams(window.location.search);
    setToken(queryParams.get("token"));

    setId(queryParams.get("id"));
  };

  useEffect(() => {
    getValidateToken();
  }, []);

  const buttonUpdateClick = async () => {
    const password = {
      newPassword: newPassword,
      retypePassword: confirmPassword,
    };

    if (!newPassword) {
      setEmptyNewPassword(true);
    } else {
      setEmptyNewPassword(false);
    }
    if (!confirmPassword) {
      setConfirmPassword(true);
    } else {
      setConfirmPassword(false);
    }
    if (nonEmpty(newPassword) && nonEmpty(confirmPassword)) {
      if (newPassword === confirmPassword) {
        try {
          const submitPassword = await resetPasswordApi(token, id, password);

          if (submitPassword.data.status === 200) {
            setAlertMessage(submitPassword.data.message);
            setShowAlert(true);
            setPasswordMisMatch(false);
          }
        } catch (error) {
          if (
            error.response.data.status === 401 ||
            error.response.data.status === 400
          ) {
            const errorMessage = error.response.data.message;
            setAlertMessage(errorMessage);
          } else {
            setAlertMessage("Invalid signature");
          }
        }
      } else {
        setPasswordMisMatch(true);
      }
    }
  };
  const navigateToLogin = () => {
    navigate(RouteConstants.LOGIN);
  };
  const providerValue = {
    buttonUpdateClick,
    newPassword,
    setNewPassword,
    confirmPassword,
    setconfirmPassword,
    newPasswordType,
    setNewPasswordType,
    confirmPasswordType,
    setConfirmPasswordType,
    passWordMisMatch,
    setPasswordMisMatch,
    emptyNewPassword,
    setEmptyNewPassword,
    emptyConfirmPassword,
    setConfirmPassword,
    showAlert,
    setShowAlert,
    alertMessage,
    navigateToLogin,
  };

  return (
    <ResetPasswordContext.Provider value={providerValue}>
      {children}
    </ResetPasswordContext.Provider>
  );
};
